<template>
  <q-list v-if="menu.length" class="text-h5">
    <q-item
      v-for="item in menu"
      :key="item.title"
      active-class="text-white text-underline"
      clickable
      no-caps
      :to="{ name: 'page', params: { slug: item.page.slug.current } }"
    >
      {{ item.title }}
    </q-item>
  </q-list>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useSettingsStore } from 'src/stores/settings'

defineOptions({ name: 'HeaderMenu' })

const settingsStore = useSettingsStore()
const { menu } = storeToRefs(settingsStore)
</script>
